/*
 send_handler_controller
 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';

const register = dataflow.register;

const state = {
	paymentmethods: null, // see structure in 'paymentmethods.js'
	paymentResultData: null
};

function registerActions() {
	function sendHandlerController(payload) {
		let accHistRef;
		let paymentFetchResultFlow;
		let sendHandlerControllerData;
		let actualSendHandlerData;
		let actualSendHandler;
		if (payload.type === constants.PAYMENTMETHODS) {
			/* Get details about payment */

			state.paymentmethods = payload.data;
		}
		if (payload.type === constants.SUBMIT_PAYMENT) {
			if (payload && payload.sendHandlerType === constants.SEND_HANDLER_CONTROLLER) {

				// Alternative code below for actualSendHandler is for Emp having GsonJerseyProvider to be able to deliver data to CreditCardIntegration as well
				sendHandlerControllerData = (payload.sendHandlerData.actualSendHandler !== undefined ? payload.sendHandlerData : payload.sendHandlerData.handler);
				actualSendHandlerData = typeof (sendHandlerControllerData.sendHandlerData) !== 'undefined' ? sendHandlerControllerData.sendHandlerData : payload.sendHandlerData;

				accHistRef = payload.accHistRef;

				paymentFetchResultFlow = payload.paymentFetchResultFlow;

				actualSendHandler = sendHandlerControllerData.actualSendHandler;

				actions.submitPayment({
					type: constants.SUBMIT_PAYMENT,
					sendHandlerData: actualSendHandlerData,
					accHistRef,
					paymentFetchResultFlow,
					sendHandlerType: actualSendHandler
				});
			}
		}
	}
	register(sendHandlerController);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/send-handler-controller.js